




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {TrosakVozila} from "@/services/BackendProxies";
import {State} from "vuex-class";

@Component({})
export default class VrsteTroskovaVozilaEditor extends mixins(ComponentBaseMixin) {
    @State vrsteTroskovaVozila!: { id: string, vrstaOdrzavanjaId: number, naziv: string }[];
    @Prop() value!: string;
    @Prop({default: false}) invalid!: boolean;

    model = '';

    async created() {
        this.model = this.value;
    }

    @Watch('value') onValueChange(value) {
        this.model = value;
    }

    @Watch('model') onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {
        const vrsteOdrzavanja = this.vrsteTroskovaVozila.find(x => x.id == value);
        this.vrsteOdrzavanja(vrsteOdrzavanja ? [vrsteOdrzavanja.vrstaOdrzavanjaId].filter(x => x != null) : []);

        const vrsteTroska = this.vrsteTroskovaVozila.find(x => x.id == value);
        this.vrsteTroska(vrsteTroska ? vrsteTroska.naziv : '');

    }

    @Emit() vrsteOdrzavanja(value) {
    }

    @Emit() vrsteTroska(value) {
    }
}
